import React from 'react';

const SECTION_COLORS = {
  'Aktuelle Beschwerden': { border: '#ef4444', bg: '#fef2f2', text: '#991b1b' },
  'Begleitsymptome': { border: '#f97316', bg: '#fff7ed', text: '#9a3412' },
  'Vorerkrankungen': { border: '#8b5cf6', bg: '#f5f3ff', text: '#5b21b6' },
  'Aktuelle Medikation': { border: '#0891b2', bg: '#ecfeff', text: '#155e75' },
  'Allergien': { border: '#dc2626', bg: '#fef2f2', text: '#991b1b' },
  'Relevante Lebensumstände': { border: '#059669', bg: '#ecfdf5', text: '#065f46' },
};

function getColorForTitle(title) {
  for (const [key, colors] of Object.entries(SECTION_COLORS)) {
    if (title.includes(key)) return colors;
  }
  return { border: '#6b7280', bg: '#f9fafb', text: '#374151' };
}

function SummaryDisplay({ summary, isProcessing, isUpdating }) {
  return (
    <div className="card">
      {isUpdating && <div className="updating-bar summary" />}
      <h2>Zusammenfassung</h2>
      {isProcessing ? (
        <div className="loading">Wird zusammengefasst...</div>
      ) : summary && summary.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {summary.map((section, index) => {
            const colors = getColorForTitle(section.title);
            return (
              <div key={index} style={{
                padding: '10px 12px',
                background: colors.bg,
                borderRadius: '8px',
                borderLeft: `3px solid ${colors.border}`
              }}>
                <div style={{
                  fontSize: '12px',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  color: colors.text,
                  marginBottom: '4px'
                }}>
                  {section.title}
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {section.items.map((item, i) => (
                    <li key={i} style={{
                      fontSize: '13px',
                      color: '#374151',
                      lineHeight: '1.5',
                      padding: '1px 0 1px 12px',
                      position: 'relative'
                    }}>
                      <span style={{
                        position: 'absolute',
                        left: 0,
                        top: '8px',
                        width: '4px',
                        height: '4px',
                        borderRadius: '50%',
                        background: colors.border,
                        display: 'inline-block'
                      }} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ color: '#9ca3af', fontSize: '14px' }}>
          Die Zusammenfassung wird während der Aufnahme automatisch erstellt.
        </div>
      )}
    </div>
  );
}

export default SummaryDisplay;
